import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import _isEqual from 'lodash/isEqual'
import _uniq from 'lodash/uniq'

const findConditionIndex = (state) => (conditionName) => {
  // console.log(1, 'find idx by', conditionName);
  let idxArray = [];
  for (let i = 0; i < state.conditions.length; i++) {
    let item = state.conditions[i];
    if (item.name.indexOf(conditionName) >= 0) {
      idxArray.push(i);
    }

    if (item.composite) {
      let idx = _findIndex(item.items, (o) => {
        return (o.name && conditionName.includes(o.name)) || o[conditionName];
        // return _isEqual(o.name, conditionName);
      });

      if (idx >= 0) {
        idxArray.push(i);
      }
    }
  }
  // console.log(1.1, 'find idx by', _uniq(idxArray));
  return _uniq(idxArray);
  // return _findIndex(state.conditions, (o) => {
  //   return o.name.indexOf(conditionName) >= 0;
  // });
};

const getCondition = (state) => (conditionName) => {
  // console.log(6, 'getters condition by name', conditionName);
  return _find(state.conditions, (o) => {
    // return o.name.indexOf(...conditionName) >= 0;
    return _isEqual(o.name, conditionName);
  });
};

const getConditionByIndex = (state) => (idx) => {
  // console.log(3, 'getters condition by index', idx);
  return state.conditions[idx];
};

export default {
  findConditionIndex,
  getCondition,
  getConditionByIndex
};
